import { render, staticRenderFns } from "./AppPanel.vue?vue&type=template&id=5bb08ec6&scoped=true&"
import script from "./AppPanel.vue?vue&type=script&lang=js&"
export * from "./AppPanel.vue?vue&type=script&lang=js&"
import style0 from "./AppPanel.vue?vue&type=style&index=0&id=5bb08ec6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb08ec6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VExpansionPanels,VProgressCircular})
